<template>
    <div>
        <rkm-area title="Exames Imagem/Laboratoriais" type="fieldset">
            <template slot="trailing">
                <rkm-button
                    @click="$refs.PedidoExame.open(data.form.dataAtual)"
                    color="primary"
                    small
                    v-if="addEnable"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>
            </template>

            <List
                :data="data"
                :show-profissional-executante="showProfissionalExecutante"
            />
        </rkm-area>

        <pedido-exame
            ref="PedidoExame"
            @createPedidoExame="handlePedidoExame"
            :key="pedidoComponentKey"
            :data="data"
            :tipo-exame-id="tipoExameId"
            :cbo-lotacao-atual="cboLotacaoAtual"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import PedidoExame from './components/pedidoExame/Modal'

// Getters
import { mapGetters } from "vuex";

// Enums
import tipoExame from '@/enums/parametrizacao/tipoExame'

export default {
    data: () => ({
        pedidoComponentKey: 0
    }),
    components: { List, PedidoExame },
    methods: {

        ...mapGetters(['getLotacao', 'getCentroCusto']),

        handlePedidoExame(pedido) {
            if(pedido.exames.length) {

                pedido.lotacao = this.getLotacao()
                pedido.centroCusto = this.getCentroCusto()

                pedido.lotacao = {
                    ocupacao: {
                        codigo: pedido.lotacao.ocupacao.codigo,
                        nome: pedido.lotacao.ocupacao.nome
                    },
                    profissional: {
                        nome: pedido.medicoSolicitanteEncaminhamento
                    }
                }

                this.pedidoComponentKey++;

                this.data.model.pedidosExames.push(pedido)
           }
        },
    },
    props: {
        data: { type: Object, required: true },
        addEnable: { type: Boolean, default: false },
        tipoExameId: { type: Number, default: tipoExame.EXAME_IMAGEM },
        cboLotacaoAtual: { type: Boolean, default: true },
        showProfissionalExecutante: { type: Boolean, default: false },
    },
}
</script>